import { Alert } from "@mui/material";
import { styled } from "@mui/material/styles";
import { deepOrange } from "@mui/material/colors";

import { useIsPreviewModeEnabled } from "./preview-mode.hooks";
import { previewModeEnabled } from "./preview-mode.utils";

const PreviewMode = () => {
  const previewEnabled = useIsPreviewModeEnabled();

  const paramAvailable =
    new URLSearchParams(window.location.search).get("previewMode") === "true";

  if (paramAvailable && !previewModeEnabled()) {
    sessionStorage.setItem("previewMode", "true");
    location.reload();
  }

  if (!previewEnabled) return null;

  return (
    <StyledAlert variant="filled" severity="warning">
      Je kijkt naar de voorvertoning van de laatste versie van het dashboard. Sluit de tab
      om uit de preview modes te gaan.
    </StyledAlert>
  );
};

export const StyledAlert = styled(Alert)`
  border-radius: 0;
  justify-content: center;
  background-color: ${deepOrange[500]};
`;

export default PreviewMode;
